import * as Context from '@terrencecrowley/context';
import * as LogAbstract from '@terrencecrowley/logabstract';
import * as Util from '@terrencecrowley/util';

export interface LogEnvironment
{
  context: Context.IContext;
}

class LogManager implements LogAbstract.ILog
{
  env: LogEnvironment;
  count: number;

  constructor(env: LogEnvironment)
  {
    this.env = env;
    this.count = 0;
  }

  dump(): void {}

  log(o: any, verbosity: number = 0): void
  {
    // Show some restraint
    if (verbosity <= this.env.context.xnumber('verbosity'))
      return;

    // Inject some standard properties
    o._time = Util.Now();
    o._count = this.count++;
    if (o.kind === undefined)
      o.kind = 'misc';
    console.log(JSON.stringify(o));
  }


  event(o: any, verbosity: number = 0): void
  {
    if (typeof o === 'string') o = { event: o };
    o.kind = 'event';
    this.log(o, verbosity);
  }

  error(o: any): void
  {
    if (typeof o === 'string') o = { message: o };
    o.kind = 'error';
    this.log(o);
  }

  value(o: any, verbosity: number = 0): void
  {
    o.kind = 'value';
    this.log(o, verbosity);
  }
}

export function create(env: LogEnvironment): LogAbstract.ILog
{
  return new LogManager(env);
}
